export const API_READ_ATTEMPTS = 3;
export const API_READ_RETRY_DELAY_MS = 500;

const wait = (delayMs) => new Promise((resolve) => setTimeout(resolve, delayMs));

export const getApiErrorStatus = (error) => Number(error?.response?.status || 0);

export const isTransientApiReadError = (error) => {
  const status = getApiErrorStatus(error);
  return status === 0 || status === 408 || status === 425 || status === 429 || status >= 500;
};

export const getWithTransientRetry = async (
  client,
  url,
  {
    attempts = API_READ_ATTEMPTS,
    retryDelayMs = API_READ_RETRY_DELAY_MS,
    requestConfig,
  } = {},
) => {
  let lastError;
  const totalAttempts = Math.max(1, attempts);

  for (let attempt = 1; attempt <= totalAttempts; attempt += 1) {
    try {
      return await client.get(url, requestConfig);
    } catch (error) {
      lastError = error;
      if (!isTransientApiReadError(error) || attempt === totalAttempts) throw error;
      await wait(retryDelayMs * attempt);
    }
  }

  throw lastError;
};
